import { memo } from "react";
import { type PropsWithOptionalTestID } from "@boi/components-core";
import { useDesignTokens } from "@boi/react-design-tokens";

import * as S from "./CharactersCounter.styled";

export type CharactersCounterProps = PropsWithOptionalTestID & {
  length: number;
  maxLength: number;
};

function CharactersCounter(props: CharactersCounterProps) {
  const { length, maxLength, testID } = props;

  const { tokens } = useDesignTokens();
  const { charactersCounter } = tokens;

  const remaining = Math.max(0, maxLength - length);

  return (
    <S.CustomCharactersCounter
      variant={charactersCounter.typography.variant}
      fontFamily={charactersCounter.typography.fontFamily}
      testID={testID}
      aria-live="polite"
    >
      {`${remaining} character${remaining !== 1 ? "s" : ""} remaining`}
    </S.CustomCharactersCounter>
  );
}

export default memo(CharactersCounter);
